<template>
  <b-container>
    <h1 class="text-center primer-fila">Establecimiento</h1>
    <hr/>
    <b-row>
      <b-col cols="12" md="6">
        <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="mostrarAlerta">
          Parámetros establecidos correctamente.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row >
      <b-col cols="12" md="6">
          <label class="typo__label" for="ajax">Unidad Educativa : </label>
          <multiselect v-model="value"  track-by="Id" label="Text" placeholder="--Seleccionar--" :options="options" :searchable="true" :allow-empty="false" :max-height="600"  @select="dispatchAction">
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.Text }}</strong></template>
            <span slot="noResult">Oops! No se encontraron resultados.</span>
          </multiselect>
        </b-col>
    </b-row>
    <b-row class="primer-fila">
      <b-col cols="12" md="6">
          <label class="typo__label" for="ajax">Nivel : </label>
          <multiselect v-model="valueNivel"  track-by="Id" label="NombreNivel" placeholder="--Seleccionar--" :options="niveles" :searchable="true" :allow-empty="false" :max-height="150" >
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.NombreNivel }}</strong></template>
            <span slot="noResult">Oops! No se encontraron resultados.</span>
          </multiselect>
        </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6">
        <b-button variant="success" class="mt-3 mb-3 float-right" v-on:click="almacenarParametros" v-if="valueNivel">Guardar</b-button>
      </b-col>
    </b-row>
    <router-link :to="'/consultasolicitud/'+value.Id +'/'+ valueNivel.Id"  v-if="mostrarAlerta"> Solicitudes </router-link>
      <router-link :to="'/registrarlicencia/'+value.Id +'/'+ valueNivel.Id"  v-if="mostrarAlerta"> Registrar </router-link>
  </b-container>
</template>
<script>

import api from '@/api';
import axios from 'axios'
import qs from 'qs'
import Multiselect from 'vue-multiselect'
import {mapGetters,mapActions} from 'vuex'

  export default{
    components: { Multiselect },
    name: 'Establecimiento',
    computed:{
      ...mapGetters(['getUserInfo', 'getUserName'])
    },
    data(){
      return{
        mostrarAlerta : false,
        value:'',
        valueNivel:'',
        options:[],
        niveles:[],
      }
    },
    methods:{
      limpiar(){
        this.value='',
        this.valueNivel=''
      },
      almacenarParametros(){
        sessionStorage.setItem("NombreUnidadEducativa",this.value.Text);
        sessionStorage.setItem("NombreNivel",this.valueNivel.NombreNivel);
        sessionStorage.setItem("UnidadEducativa",this.value.Id);
        sessionStorage.setItem("NivelEnseñanza",this.valueNivel.Id);
        this.mostrarAlerta=true;
        //this.limpiar();
      },
      dispatchAction(unidad){
        this.obtenerNiveles(unidad.Id);
      },
      mostrarEstablecimientos(){
        for (var i = 0; i < this.getUserInfo.Establecimientos.length; i++) {
          this.options.push({
            Id: this.getUserInfo.Establecimientos[i].UnidadEducativa_Id,
            Text:this.getUserInfo.Establecimientos[i].DisplayUnidadEducativa
          });
        }
      },
      obtenerNiveles(id) {
        this.niveles = [];
        axios.get(api.url + '/NivelEnseñanza/GetLista/', {
          params: {
            'listParams.unidadEducativa_Id': id
          }
        }).then(response => {
          this.niveles = [];
          response.data.rows.forEach(element => {
            this.niveles.push(element);
          });
        }).catch(e => {
          console.log("Error: " + e);
        })
      }
    },
    created(){
      this.mostrarEstablecimientos();
    }
  }
</script>

<style>
.primer-fila {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/configuraciones/Establecimiento.vue